import { lazy } from "react";
import { useTranslation } from "react-i18next";
import { Navbar } from "@/components/layout/Navbar";
import { HeroSection } from "@/components/sections/HeroSection";
import { ProductsSection } from "@/components/sections/ProductsSection";
import { DeferredSection } from "@/components/common/DeferredSection";
import StructuredData from "@/components/seo/StructuredData";

const PqcJourneySection = lazy(() =>
  import("@/components/sections/PqcJourneySection").then((m) => ({ default: m.PqcJourneySection }))
);
const ServicesSection = lazy(() =>
  import("@/components/sections/ServicesSection").then((m) => ({ default: m.ServicesSection }))
);
const BenefitsSection = lazy(() =>
  import("@/components/sections/BenefitsSection").then((m) => ({ default: m.BenefitsSection }))
);
const TrustSection = lazy(() =>
  import("@/components/sections/TrustSection").then((m) => ({ default: m.TrustSection }))
);
const PartnersSection = lazy(() =>
  import("@/components/sections/PartnersSection").then((m) => ({ default: m.PartnersSection }))
);
const BlogSection = lazy(() =>
  import("@/components/sections/BlogSection").then((m) => ({ default: m.BlogSection }))
);
const Footer = lazy(() =>
  import("@/components/layout/Footer").then((m) => ({ default: m.Footer }))
);


import { Helmet } from "react-helmet-async";

const Index = () => {
  const { t } = useTranslation();

  const orgSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "ITAC",
    "url": "https://itac.co",
    "logo": "https://itac.co/logo.png",
    "description": "Líder entre las empresas tecnológicas en Colombia con más de 20 años de experiencia. Especialistas en IA aplicada al desarrollo, ciberseguridad post-cuántica y observabilidad.",
    "foundingDate": "2004",
    "knowsAbout": ["Inteligencia Artificial", "Ciberseguridad Post-Cuántica", "Desarrollo de Software a medida", "ISO 27001", "CMMI Nivel 5"],
    "award": ["3er Lugar Great Place to Work Colombia 2025", "Certificación ISO 27001", "Prácticas CMMI Nivel 5"],
    "contactPoint": { "@type": "ContactPoint", "contactType": "customer service", "areaServed": "CO", "availableLanguage": "Spanish" }
  };

  return (
    <>
      <Helmet>
        <title>{t("seo.indexTitle")}</title>
        <meta property="og:site_name" content="ITAC" />
        <meta property="og:title" content={t("seo.indexTitle")} />
        <meta name="description" content={t("seo.indexDescription")} />
        <meta name="keywords" content="MFT, transferencia segura archivos, API gateway, seguridad empresarial, automatización B2B, ITAC" />
        <link rel="canonical" href="https://itac.co/" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://itac.co/" />
        <meta property="og:description" content={t("seo.indexDescription")} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={t("seo.indexTitle")} />
        <meta name="twitter:description" content={t("seo.indexDescription")} />
      </Helmet>
    <StructuredData data={orgSchema} />
      
      <div className="min-h-screen bg-background">
        <Navbar />
        <main>
          <HeroSection />
          <ProductsSection />
          <DeferredSection minHeight={520}>
            <PqcJourneySection />
          </DeferredSection>
          <DeferredSection minHeight={640}>
            <ServicesSection />
          </DeferredSection>
          <DeferredSection minHeight={600}>
            <BenefitsSection />
          </DeferredSection>
          <DeferredSection minHeight={600}>
            <TrustSection />
          </DeferredSection>
          <DeferredSection minHeight={360}>
            <PartnersSection />
          </DeferredSection>
          <DeferredSection minHeight={560}>
            <BlogSection />
          </DeferredSection>
        </main>
        <DeferredSection minHeight={480}>
          <Footer />
        </DeferredSection>
      </div>
    </>
  );
};

export default Index;
